import { observer } from "mobx-react-lite";
import { useContext, useEffect, useRef, useState } from "react";
import Clicker from "../ui/Clicker";
import TableBlock from "./tableBlock";
import AutoTextArea from "../ui/AutoTextArea";
import MultiSwitcherStage from "../ui/MultiSwitcherStage";
import { ReactComponent as RemoveIcon } from "../../images/icons/contextRemove.svg"
import useNotification from "../../hooks/useNotification";
import { Context } from "../..";

const TableRow = ({ value, setValue, saveValue, onDelete, index, isNew }) => {
    const { store } = useContext(Context);
    const { error } = useNotification();
    const rowRef = useRef(null);
    const inputRef = useRef(null);
    const [editMode, setEditMode] = useState(isNew ? true : false);
    const [isRemove, setRemove] = useState(false);

    useEffect(() => {
        if (isNew && inputRef.current && store.userInfo && store.userInfo.isLicensed == true) {
            setEditMode(true);
            inputRef.current.focus();
        }
    }, []);
    useEffect(() => {
        if (editMode && inputRef.current) {
            inputRef.current.focus();
        }
    }, [editMode]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (rowRef.current && !rowRef.current.contains(event.target) && event.target.id != "notificationButton") {
                save();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [value, editMode]);

    function save() {
        if (!editMode) return;
        if (!inputRef.current) return;
        inputRef.current.blur();

        const confirmSave = () => {
            setEditMode(false);
            saveValue(value);
        }

        const handleNewItem = () => {
            if (value.interval == 1 && value.time == 0) {
                if (!validateFields()) onDelete();
                else confirmSave();
            } else {
                if (validateFields(true)) confirmSave();
            }
        }

        if (!isNew && validateFields(true)) confirmSave();
        else if (isNew) handleNewItem();
    }
    const validateFields = (showError) => {
        if (value.name.replace(" ", "") == "") {
            inputRef.current.className = "error";
            if (showError) error('Поле "Наименование" не может быть пустым', { showBtns: false });
            return false;
        }
        inputRef.current.className = "";
        return true;
    }

    let timeoutRemove;
    const remove = () => {
        if (isRemove === true) return;
        setRemove(true);
        if (isNew) {
            onDelete();
            return;
        }
        timeoutRemove = setTimeout(() => setRemove(false), 3000); 
    }
    const confirmRemove = () => {
        if (isRemove === false) return;
        clearTimeout(timeoutRemove);
        setRemove(false);
        onDelete();
    }

    return (
        <li 
            ref={rowRef} 
            className={`${editMode?"active":""}${isRemove?" remove":""}`}
        >
            <div className="num">{index+1}.</div>
            <div className="name">
                <div 
                    className="text" 
                    style={{ cursor: "pointer" }} 
                    onClick={() => store.userInfo && store.userInfo.isLicensed && setEditMode(true)}
                >
                    {editMode 
                        ? <AutoTextArea 
                            ref={inputRef}
                            active={editMode} 
                            value={value.name} 
                            setValue={(value) => setValue(value, "name")}
                            save={save}
                        />
                        : value.name 
                    }
                </div>
                {/* <ul className="tags"></ul> */}
            </div>
            <div className="attrs">
                <div className="tdContainer"><Clicker 
                    value={value.interval} 
                    setValue={(newValue) => {
                        if (!store.userInfo || store.userInfo.isLicensed == false) return
                        setValue(newValue, "interval")
                        if (!editMode) saveValue({ ...value, interval: newValue });
                    }} 
                    max={12}
                    isDecimal={true}
                    step={1}
                    disabled={!store.userInfo || store.userInfo.isLicensed == false}
                /></div>
                <TableBlock value={value.time} disabled={!store.userInfo || store.userInfo.isLicensed == false} save={save} setValue={(newValue) => {
                    setValue(newValue, "time");
                    if (!editMode) saveValue({ ...value, time: newValue });
                }} />
                <div className="tdContainer">
                    <MultiSwitcherStage
                        values={[{ name: "Есть" }, { name: "Нет" }]}
                        selectValue={(selectedIndex) => {
                            const selected = selectedIndex == 0 ? false : true;
                            if (selected == value.isRequired) return;
                            setValue(selected, 'isRequired');
                            if (!editMode) saveValue({ ...value, isRequired: selected });
                        }}
                        backIsWhite={true}
                        forceSelected={value.isRequired == true ? 1 : 0}
                        defaultValue={value.isRequired == true ? 1 : 0}
                        disabled={!store.userInfo || store.userInfo.isLicensed == false}
                    />
                </div>
                <div className="tdContainer">
                    <MultiSwitcherStage
                        values={[{ name: "Нет" }, { name: "Да" }]}
                        selectValue={(selectedIndex) => {
                            const selected = selectedIndex == 0 ? true : false;
                            if (selected == value.isStatic) return;
                            setValue(selected, 'isStatic');
                            if (!editMode) saveValue({ ...value, isStatic: selected });
                        }}
                        backIsWhite={true}
                        forceSelected={value.isStatic == true ? 0 : 1}
                        defaultValue={value.isStatic == true ? 0 : 1}
                        disabled={!store.userInfo || store.userInfo.isLicensed == false}
                    />
                </div>
                <button 
                    className="remove"
                    onClick={() => {
                        if (!store.userInfo || store.userInfo.isLicensed == false) return;
                        if (isRemove === false) remove();
                        else confirmRemove();
                    }}
                >
                    <RemoveIcon/>
                </button>
            </div>
        </li>
    );
}

export default observer(TableRow);
